import React, { useContext } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { HashLink } from "react-router-hash-link";

const CardsConcierge = ({ cards }) => {
    const { t } = useTranslation();
    return (
        <section className="p-4 mb-5">
        <div className="container-fluid py-5">
            <div className="row justify-content-around">
                <h2 className="text-center mb-5 pb-5 text-uppercase title">{t("InVillaPersonalConcierge")}</h2>
                {cards && cards.map((card, index) => (
                    <div key={index} className="col-12 col-sm-12 col-md-6 col-lg-3 mb-4 mt-lg-5">
                        <div className="card-concierge text-center border-custom position-relative overflow-hidden">
                            {card?.image?.src && (
                                <div className="card-concierge-img-top">
                                    <img src={card?.image?.src ?? ""} alt={card?.image?.alt ?? ""} />
                                </div>
                            )}
                            <div className="card-concierge-body flex-column align-items-center">
                                <h2 className="sub-title mb-0 text-uppercase">{card?.title ?? ""}</h2>
                                <div className="card-concierge-overlay">
                                    <p className="paragraph fs-14 mb-4 mt-4">{card?.description ?? ""}</p>
                                    <div className="container-cta-concierge-card arrowEffectContainer">
                                        <HashLink target={card?.cta?.target ?? "_self"} to={card?.cta?.link ?? "#"} className="link text-uppercase m-auto">{card?.cta?.text ?? ""}
                                            <FontAwesomeIcon icon={faArrowRight} className="paddingArrow effectArrow"/>
                                        </HashLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        </section>
    );
};

export default CardsConcierge;
